import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'
import { HeaderComponent } from '../header'

const SCROLLTRACK_ATTRIBUTE = 'data-with-scrolltrack'
const HEADER_SELECTOR = 'header-component'

export class ProductInfo extends BaseComponent {
  headerHeight: number
  defaultTopSpace: number
  infoHeight: number
  isToSetMoreHeight: boolean

  mountComponent() {
    const isWithScrollTrack = this.hasAttribute(SCROLLTRACK_ATTRIBUTE)

    if (!isWithScrollTrack) {
      return
    }

    customElements.whenDefined('header-component').then(() => {
      this.setDimentions()
      this.addListener(window, 'scroll', this.handleScroll)
    })

    if (this.isEditor) {
      this.editor.on('SECTION_LOAD', this.handleSectionLoad)
    }
  }

  setDimentions = () => {
    this.defaultTopSpace = 16
    this.infoHeight = this.getBoundingClientRect().height

    const header: HeaderComponent = $el(HEADER_SELECTOR)
    const headerSection = header.section

    this.headerHeight = headerSection.offsetHeight

    this.isToSetMoreHeight = header.getAttribute('is-sticky') === 'static'
  }

  handleScroll = () => {
    const topSpace = this.isToSetMoreHeight
      ? this.defaultTopSpace + this.headerHeight
      : this.defaultTopSpace

    const viewportHeight = window.innerHeight - topSpace

    if (window.scrollY > 0 && this.infoHeight > viewportHeight) {
      this.style.top = `${viewportHeight - this.infoHeight}px`
    } else {
      this.style.top = `${topSpace}px`
    }
  }

  handleSectionLoad = () => {
    this.setDimentions()
  }
}
